import { productFamilyIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const deleteProductFamilies = {
  name: "deleteProductFamilies" as const,
  input: z.object({
    productFamilyIds: z.array(productFamilyIdFormat.schema).min(1),
    acknowledgeNonDraftPos: z.boolean().optional(),
  }),

  output: z.object({
    results: z.array(
      z.object({
        productFamilyId: productFamilyIdFormat.schema,
        success: z.boolean(),
        error: z.string().optional(),
        nonDraftPoConfirmationRequired: z.boolean().optional(),
      }),
    ),
  }),
};
